export default {
  pt: {},
  en: {},
  es: {},
}
